import { RouteStrategy } from './routeStrategy';

const authenticatedRouteStrategies = {
  deepLink: new RouteStrategy(
    (context) => {
      const { deeplinkPath, deeplinkPathSet } = context;
      if (deeplinkPath === '/') {
        return false;
      }
      const result = deeplinkPath
        && Array.from(deeplinkPathSet).some((path) => deeplinkPath?.includes(path));
      return result;
    },
    (context) => context.deeplinkPath,
    40,
  ),

  profileCompleted: new RouteStrategy(
    (context) => {
      const { hasCompletedPortrait, hasCompletedProfile } = context;
      return hasCompletedPortrait && !hasCompletedProfile;
    },
    () => '/profile-completed',
    30,
  ),

  oneTimeScreen: new RouteStrategy(
    (context) => context.viewOneTimeScreen,
    () => '/new-feature',
    20,
  ),

  default: new RouteStrategy(
    () => true,
    () => '/tabs/feed',
    0,
  ),
};

export default authenticatedRouteStrategies;
